// src/components/Form.jsx
import React from 'react';

function fmtRange(start, end) {
	if (!start && !end) return 'Select a start and end date';
	if (start && !end) return `Start: ${start.toLocaleDateString()}`;
	return `${start.toLocaleDateString()} → ${end.toLocaleDateString()}`;
}

function StepHeader({ step, title, subtitle }) {
	return (
		<div className='flex items-start justify-between gap-4'>
			<div className='flex items-start gap-3'>
				<div className='mt-0.5 flex h-7 w-7 items-center justify-center rounded-full bg-indigo-600 text-xs font-semibold text-white'>
					{step}
				</div>
				<div>
					<div className='text-sm font-semibold text-slate-900'>{title}</div>
					{subtitle ? (
						<div className='mt-0.5 text-xs text-slate-600'>{subtitle}</div>
					) : null}
				</div>
			</div>
		</div>
	);
}

export default function Form({
	name,
	setName,
	disabled = false,
	startDate,
	endDate,
	onOpenCalendar,
}) {
	return (
		<div>
			{/* Title + context */}
			<div className='flex items-start justify-between gap-4'>
				<div>
					<div className='text-xl font-semibold text-slate-900'>
						Nana’s Hotel
					</div>
					<div className='mt-1 text-xs text-slate-600'>Life's a beach.</div>
				</div>

				<div className='hidden sm:flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs text-slate-700'>
					<span className='h-1.5 w-1.5 rounded-full bg-emerald-500' />
					Family booking
				</div>
			</div>

			{/* Step 1 */}
			<div className='mt-5 rounded-2xl border border-slate-200 bg-white p-4'>
				<StepHeader
					step={1}
					title='Your name'
					subtitle='So we know who the reservation is for.'
				/>

				<div className='mt-3'>
					<label
						className='block text-xs font-medium text-slate-700 mb-2'
						htmlFor='name'
					>
						Name
					</label>
					<input
						id='name'
						value={name}
						onChange={(e) => setName(e.target.value)}
						type='text'
						autoComplete='name'
						required
						disabled={disabled}
						className='w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 outline-none focus:ring-4 focus:ring-indigo-100 focus:border-indigo-300 disabled:opacity-60'
						placeholder='Enter your name'
					/>
				</div>
			</div>

			{/* Step 2 */}
			<div className='mt-4 rounded-2xl border border-slate-200 bg-white p-4'>
				<div className='flex items-start justify-between gap-4'>
					<StepHeader
						step={2}
						title='Choose dates'
						subtitle='Click to select a start date, then an end date.'
					/>
					<button
						type='button'
						onClick={onOpenCalendar}
						disabled={disabled}
						className='mt-0.5 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50 transition disabled:opacity-60'
					>
						Open calendar
					</button>
				</div>

				<div className='mt-3'>
					<button
						type='button'
						onClick={onOpenCalendar}
						disabled={disabled}
						className='w-full text-left rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none focus:ring-4 focus:ring-indigo-100 focus:border-indigo-300 disabled:opacity-60'
						aria-label='Choose start and end dates'
					>
						{fmtRange(startDate, endDate)}
					</button>
					<div className='mt-1 text-xs text-slate-600'>
						Reserved dates are blocked out.
					</div>
				</div>
			</div>
		</div>
	);
}
